import { ENDPOINTS } from "@horseed/shared/endpoints";
import { API_BASE_URL, apiRequest, authHeader } from "./http";

const { NOTIFICATIONS } = ENDPOINTS;

// GET /api/v1/notifications/customer
export async function getNotifications(token) {
  const json = await apiRequest(`${API_BASE_URL}${NOTIFICATIONS.CUSTOMER}`, { headers: authHeader(token) });
  return json?.data ?? [];
}

// GET /api/v1/notifications/customer/unread-count
export async function getUnreadCount(token) {
  const json = await apiRequest(`${API_BASE_URL}${NOTIFICATIONS.UNREAD_COUNT}`, {
    headers: authHeader(token),
  });
  return json?.data ?? 0;
}

// PUT /api/v1/notifications/customer/{id}/read
export async function markRead(id, token) {
  const json = await apiRequest(`${API_BASE_URL}${NOTIFICATIONS.MARK_READ(id)}`, {
    method: "PUT",
    headers: authHeader(token),
  });
  return json?.data ?? true;
}

// PUT /api/v1/notifications/customer/read-all
export async function markAllRead(token) {
  const json = await apiRequest(`${API_BASE_URL}${NOTIFICATIONS.MARK_ALL_READ}`, {
    method: "PUT",
    headers: authHeader(token),
  });
  return json?.data ?? true;
}
